(function($) {
/*
	$(".hlidaci-pes-button-2").ajaxify({
		refresh: [
			"#refresh-target"
		],
		history: false,
		onStart: function(data) {
			alert("yes");
		},
		onFinish: function() {
			alert("yes");
		}
	});

	$(".hlidaci-pes-button-1").ajaxify({
		refresh: [
			"#refresh-target"
		],
		history: false,
		onStart: function(data) {
			alert("yes");
		},
		onFinish: function() {
			alert("yes");
		}
	});
*/

})(jQuery);
